import { render, staticRenderFns } from "./updateCompany.vue?vue&type=template&id=0637546a&scoped=true&"
import script from "./updateCompany.vue?vue&type=script&lang=ts&"
export * from "./updateCompany.vue?vue&type=script&lang=ts&"
import style0 from "./updateCompany.vue?vue&type=style&index=0&id=0637546a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637546a",
  null
  
)

export default component.exports